import { useEffect, useState } from "react";
import { getIcon } from "../../../utils/amenities";

const AmenitiesProject = ({ amenities = [] }) => {
   const [items, setItems] = useState([]);

   useEffect(() => {
     setItems([...amenities]); 
   }, [amenities]);

   if (!items.length) return null;

  return (
    <div className="w-full">
      <div
        className="bg-white p-4 md:p-6 lg:p-8 w-full mx-auto rounded-lg border"
      >
        {/* Title */}
        <h2
          className="font-medium text-[#031722] tracking-[0.01em] text-lg sm:text-xl md:text-2xl lg:text-[24px] mb-1 sm:mb-2 md:mb-3 lg:mb-4"
        >
          Amenities
        </h2>

        {/* Divider */}
        <div
          className="border-t border-gray-300 mb-3 sm:mb-4 md:mb-6 lg:mb-8"
        ></div>

        {/* Amenity Grid */}
        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-3 md:gap-4 lg:gap-5 xl:gap-6">
          {amenities.map((item, index) => (
            <div
              key={item?.key || index}
              className="flex flex-col items-center justify-center bg-white rounded-xl border border-gray-200 hover:border-blue-300 hover:shadow-md transition-all duration-300 p-2 sm:p-3 md:p-4 lg:p-5 xl:p-6 aspect-square group"
            >
              <img
                src={getIcon(item?.key)}
                alt={item?.label}
                className="w-8 h-8 sm:w-9 sm:h-9 grayscale md:w-10 md:h-10 lg:w-11 lg:h-11 object-contain group-hover:scale-110 transition-transform duration-300"
              />

              <span className="font-medium text-[#545454] tracking-[0.01em] leading-[150%] text-center text-[11.14px] mt-1 sm:mt-2">
                {item?.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AmenitiesProject;
